import { CacheProvider } from '@emotion/react';

import { IslandUiProvider } from 'shared/islands/island-ui-provider.jsx';
import { createIslandEmotionCache } from 'shared/islands/create-island-emotion-cache.js';

/** @type {import('@emotion/cache').EmotionCache | null} */
let islandEmotionCache = null;

/**
 * @returns {import('@emotion/cache').EmotionCache}
 */
function getIslandEmotionCache() {
	if (islandEmotionCache === null) {
		islandEmotionCache = createIslandEmotionCache();
	}

	return islandEmotionCache;
}

/**
 * Client hydration tree matching SSR (`shared/islands/render-island-tree.mjs`).
 * @param {import('react').CreateElement} createElement
 * @param {import('react').ComponentType<Record<string, unknown>>} Component
 * @param {Record<string, unknown>} props
 * @param {Element} islandRootElement
 * @returns {import('react').ReactElement}
 */
export function wrapIslandTree(createElement, Component, props, islandRootElement) {
	return createElement(
		CacheProvider,
		{ value: getIslandEmotionCache() },
		createElement(
			IslandUiProvider,
			{ islandRootElement },
			createElement(Component, props),
		),
	);
}
